import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStamp,
  faIdCard,
  faPalette,
  faMagic,
} from "@fortawesome/free-solid-svg-icons";

const DesignsPage = () => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="flex items-center gap-4 mb-8">
        <span className="text-4xl">🎨</span>
        <h1 className="text-3xl font-bold">Stamp & Card Designs</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <img
            src="https://images.unsplash.com/photo-1585336261022-680e295ce3fe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
            alt="Design samples"
            className="rounded-lg shadow-md w-full h-64 object-cover"
          />

          <div className="mt-6 bg-white p-6 rounded-lg shadow-sm border border-gray-100">
            <h2 className="text-xl font-semibold mb-4">Pricing Packages</h2>
            <div className="space-y-4">
              <div className="flex justify-between items-center p-3 bg-gray-50 rounded">
                <div className="flex items-center gap-3">
                  <FontAwesomeIcon icon={faStamp} className="text-purple-500" />
                  <span>Loyalty Stamp Design</span>
                </div>
                <span className="font-bold">8,000 MMK</span>
              </div>

              <div className="flex justify-between items-center p-3 bg-gray-50 rounded">
                <div className="flex items-center gap-3">
                  <FontAwesomeIcon icon={faIdCard} className="text-blue-500" />
                  <span>Gift Card Design</span>
                </div>
                <span className="font-bold">10,000 MMK</span>
              </div>

              <div className="flex justify-between items-center p-3 bg-gray-50 rounded">
                <div className="flex items-center gap-3">
                  <FontAwesomeIcon
                    icon={faPalette}
                    className="text-green-500"
                  />
                  <span>Branded Stamp Set (5)</span>
                </div>
                <span className="font-bold">30,000 MMK</span>
              </div>
            </div>

            <button className="mt-6 w-full bg-black text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition">
              Order Custom Design
            </button>
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-4">Design Process</h2>

          <div className="space-y-6 mb-8">
            <div className="flex gap-4">
              <div className="bg-black text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                1
              </div>
              <div>
                <h3 className="font-medium">Consultation</h3>
                <p className="text-gray-600">
                  We discuss your brand identity and requirements
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="bg-black text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                2
              </div>
              <div>
                <h3 className="font-medium">Concept Drafts</h3>
                <p className="text-gray-600">
                  Receive 2-3 initial design concepts
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="bg-black text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                3
              </div>
              <div>
                <h3 className="font-medium">Revisions</h3>
                <p className="text-gray-600">
                  Two rounds of refinements included
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="bg-black text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                4
              </div>
              <div>
                <h3 className="font-medium">Final Delivery</h3>
                <p className="text-gray-600">
                  Get print-ready files in all required formats
                </p>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 p-6 rounded-lg">
            <div className="flex items-center gap-3 mb-3">
              <FontAwesomeIcon icon={faMagic} className="text-yellow-500" />
              <h3 className="font-semibold text-lg">Premium Add-ons</h3>
            </div>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-black rounded-full"></span>
                <span>3D mockups (+5,000 MMK)</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-black rounded-full"></span>
                <span>Animation (+8,000 MMK)</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-black rounded-full"></span>
                <span>Printing coordination (+7,000 MMK)</span>
              </li>
            </ul>
          </div>

          <div className="mt-6">
            <h3 className="font-semibold mb-3">Sample Designs</h3>
            <div className="grid grid-cols-3 gap-3">
              <img
                src="https://images.unsplash.com/photo-1605000797499-95a51c5269ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80"
                alt="Design 1"
                className="rounded h-24 object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1600185365483-26d7a4cc7519?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1025&q=80"
                alt="Design 2"
                className="rounded h-24 object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1605000797499-95a51c5269ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80"
                alt="Design 3"
                className="rounded h-24 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignsPage;
